import { useRouter } from 'next/router';
import { useMemo } from 'react';

const addPreviewToUrl = (url: string): string => {
  const newUrl = new URL(url);
  newUrl.searchParams.set('preview', 'true');
  return newUrl.toString();
};

export const usePlayerTalkData = video => {
  const router = useRouter();
  const { playerData: acmePlayerData } = video;

  return useMemo(() => {
    if (!acmePlayerData) return null;

    try {
      const playerDataObject = JSON.parse(acmePlayerData);

      if (router.query.preview !== 'true') {
        return playerDataObject;
      }

      if (playerDataObject.resources?.hls?.stream) {
        playerDataObject.resources.hls.stream = addPreviewToUrl(
          playerDataObject.resources.hls.stream
        );
      }

      if (playerDataObject.resources?.hls?.metadata) {
        playerDataObject.resources.hls.metadata = addPreviewToUrl(
          playerDataObject.resources.hls.metadata
        );
      }

      return playerDataObject;
    } catch (error) {
      console.error('Error parsing player data:', error);
      return null;
    }
  }, [acmePlayerData, router.query.preview]);
};
